/* Import Local Modules */
import LocatorManufacturingLogUploadAction from "./LocatorManufacturingLogUploadAction.js";
import LocatorArchiveLogUploadAction from "./LocatorArchiveLogUploadAction.js";
import LocatorManufacturingLogRevertAction from "./LocatorManufacturingLogRevertAction.js";
import LocatorShipmentLogUploadAction from "./LocatorShipmentLogUploadAction.js";
import BeaconShipmentLogUploadAction from "./BeaconShipmentLogUploadAction.js";
import BeaconShipmentLogRevertAction from "./BeaconShipmentLogRevertAction.js";
export default {
  install(molten) {
    molten.addPlugin('Action', LocatorManufacturingLogUploadAction);
    molten.addPlugin('Action', LocatorManufacturingLogRevertAction);
    molten.addPlugin('Action', LocatorShipmentLogUploadAction);
    molten.addPlugin('Action', BeaconShipmentLogUploadAction);
    molten.addPlugin('Action', BeaconShipmentLogRevertAction);
    molten.addPlugin('Action', LocatorArchiveLogUploadAction);
  }
};